"use client";

import { c as _c } from "react/compiler-runtime";
export function HSeparator() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="w-px h-5 bg-border mx-1" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}